import React from 'react';

function DownloadIcon({
  className,
}: BaseIcon): JSX.Element {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
    >
      <path
        fill="#0E0E11"
        d="M7.5978179,12.8212891c0.0947266,0.1083984,0.2314453,0.1708984,0.3759766,0.1708984
        c0.1445308,0,0.2812495-0.0625,0.3759761-0.1708984l3.5-4c0.1826172-0.2080078,0.1611328-0.5234375-0.046875-0.7050781
        c-0.2060547-0.1816406-0.5224609-0.1621094-0.7050781,0.046875l-2.5976562,2.9679565V0.4941406c0-0.2763672-0.2236328-0.5-0.5-0.5
        c-0.2763667,0-0.4999995,0.2236328-0.4999995,0.5v10.6971436L4.849771,8.1630859
        c-0.1826172-0.2089844-0.4980469-0.2285156-0.7050781-0.046875c-0.2080078,0.1816406-0.2294922,0.4970703-0.046875,0.7050781
        L7.5978179,12.8212891z"
      />
      <path
        fill="#0E0E11"
        d="M15.5001612,11c-0.2763672,0-0.5,0.2236328-0.5,0.5V15h-14v-3.5c0-0.2763672-0.2236328-0.5-0.5-0.5
        s-0.5,0.2236328-0.5,0.5v4c0,0.2763672,0.2236328,0.5,0.5,0.5h15c0.2763672,0,0.500001-0.2236328,0.500001-0.5v-4
        C16.0001621,11.2236328,15.7765284,11,15.5001612,11z"
      />
    </svg>
  );
}

export default DownloadIcon;
